export class nodeResolverModel {
  acme: boolean;
  adminonly: boolean;
  allow_indexing: boolean;
  custom_support_url: string;
  default_language: string;
  default_questionnaire: string;
  description: string;
  disable_privacy_badge: boolean;
  disable_submissions: boolean;
  enable_admin_exception_notification: boolean;
  enable_custom_privacy_badge: boolean;
  enable_developers_exception_notification: boolean;
  enable_scoring_system: boolean;
  enable_signup: boolean;
  encryption: boolean;
  escrow: boolean;
  hostname: string;
  latest_version: string;
  log_accesses_of_internal_users: boolean;
  log_level: string;
  maximum_filesize: number;
  mode: string;
  name: string;
  password_change_period: number;
  pgp: boolean;
  rootdomain: string;
  show_contexts_in_alphabetical_order: boolean;
  signup_tos1_enable: boolean;
  signup_tos2_enable: boolean;
  simplified_login: boolean;
  subdomain: string;
  threshold_free_disk_megabytes_high: number;
  threshold_free_disk_megabytes_low: number;
  threshold_free_disk_percentage_high: number;
  threshold_free_disk_percentage_low: number;
  timezone: number;
  tor: boolean;
  two_factor: boolean;
  unread_reminder_time: number;
  uuid: string;
  version: string;
  viewer: boolean;
  changelog: string;
  license: string;
  languages_supported: {
    code: string;
    name: string;
    native: string;
  }[];
  languages_enabled: string[];
  root_tenant: boolean;
  update_available: boolean;
  contexts_clarification: string;
  custom_privacy_badge_text: string;
  disclaimer_text: string;
  footer_whistleblowing_policy: string;
  footer_privacy_policy: string;
  user_privacy_policy_text: string;
  footer: string;
  header_title_homepage: string;
  presentation: string;
  signup_tos1_checkbox_label: string;
  signup_tos1_text: string;
  signup_tos1_title: string;
  signup_tos2_checkbox_label: string;
  signup_tos2_text: string;
  signup_tos2_title: string;
  whistleblowing_button: string;
  whistleblowing_question: string;
  css: string[];
  favicon: string[];
  logo: string[];
  script: string[];
  onionservice: string;
  user_privacy_policy_url: string;
  can_postpone_expiration: boolean;
}
